import React, { useCallback, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'react-native-modal';
import { useDispatch } from 'src/state/redux';
import { DNABox, DNAButton, DNACheckbox, DNADivider, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';
import { useMeetingsState } from 'src/state/context/Meetings/MeetingsStateProvider';
import LocalStorageKeys from 'src/components/Authenticator/constants';

const styles = StyleSheet.create({
  container: {
    width: 560,
    backgroundColor: colors['color-text-white'],
    alignSelf: 'center',
    borderRadius: 4,
  },
  header: {
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  body: {
    paddingBottom: 24,
    paddingTop: 24,
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  footer: {
    paddingVertical: 16,
    paddingHorizontal: 16,
  },
  primaryText: {
    color: colors['color-text-light-primary'],
  },
  secondaryText: {
    color: colors['color-text-light-secondary'],
  },
})

const HelpInstructionsModal: React.FC = () => {
  const dispatch = useDispatch();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const closeModal = useCallback(() => dispatch(DNAModalActions.closeModal()), [dispatch]);
  const handleAcknowledge = useCallback(() => {
    if (doNotShowAgain) {
      localStorage.setItem(LocalStorageKeys.BEACON_3PC_HELP_INSTRUCTIONS_MODAL, JSON.stringify(true));
    }
    closeModal();
  }, [doNotShowAgain, closeModal]);

  return (
    <Modal
      isVisible={true}
      hasBackdrop={true}
    >
      <DNABox spacing="between" appearance="col" style={styles.container}>
        {/* HEADER */}
        <DNABox fill appearance="row" spacing="between" alignY="center" style={styles.header} childFill={2}>
          <DNAText h5 style={styles.primaryText}>Presenter Window</DNAText>
          <DNAButton
            appearance="ghost"
            status="tertiary"
            iconLeft="x"
            onPress={closeModal}
          />
        </DNABox>
        <DNADivider />
        {/* BODY */}
        <DNABox appearance="col" spacing="md" style={styles.body}>
          <DNAText style={styles.secondaryText}>
            {/* eslint-disable-next-line max-len */}
            This is your private window, be sure to select the "Beacon Share" window when sharing your screen with others.
          </DNAText>
          <DNABox appearance="row" spacing="sm">
            <DNACheckbox checked={doNotShowAgain} onChange={setDoNotShowAgain} />
            <DNAText style={styles.primaryText}>
              Don’t show this again
            </DNAText>
          </DNABox>
        </DNABox>
        <DNADivider />
        {/* FOOTER */}
        <DNABox appearance="row" spacing="sm" alignX="end" style={styles.footer}>
          <DNAButton
            status="primary"
            colorMode="dark"
            onPress={handleAcknowledge}
          >
            Got it
          </DNAButton>
        </DNABox>
      </DNABox>
    </Modal>
  )
}

const HelpInstructionsModalWrapper: React.FC = () => {
  const dispatch = useDispatch();
  const { isMainPlayer } = useMeetingsState();

  useEffect(() => {
    if (!isMainPlayer) return;

    const storedValue = localStorage.getItem(LocalStorageKeys.BEACON_3PC_HELP_INSTRUCTIONS_MODAL);
    const shouldNotShow = storedValue ? JSON.parse(storedValue) : false;
    if (shouldNotShow) return;

    dispatch(DNAModalActions.setModal({
      isVisible: true,
      allowBackdropCancel: false,
      backdropVisible: true,
      component: () => <HelpInstructionsModal/>,
    }))
  }, [])

  return null;
}

export default HelpInstructionsModalWrapper;
